<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { i18nRender } from '@/locales'

export default {
  data () {
    return {
    }
  },
  computed: {
    locale () {
      // 只是为了切换语言时，更新标题
      const { title } = this.$route.meta
      title && (setDocumentTitle(`${i18nRender(title)} - ${domTitle}`))
      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    }
  },
  created () {
    this.setEnvironment()
  },
  methods: {
    setEnvironment () {
      let str = ''
      switch (window.location.origin) {
        case 'http://localhost:8000':
          str = '本地'
          break
        case 'http://47.106.34.165':
          str = '测试'
          break
        case 'https://www.hehuitech.cn':
          str = '生产'
          break
        default:
          str = window.location.origin
          break
      }
      localStorage.setItem('env', str)
    }
  }
}
</script>
